import { render, staticRenderFns } from "./MoonPaySellComponent.vue?vue&type=template&id=25e32794&scoped=true&"
import script from "./MoonPaySellComponent.vue?vue&type=script&lang=js&"
export * from "./MoonPaySellComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25e32794",
  null
  
)

export default component.exports